import { QuestionPlanMealConditions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/meal-conditions";

import { usePlanMealConditions } from "./hooks";

export const QuestionPlanMealConditions = () => {
	const { isEdited, hasError, error, rawIncludedMeals, onToggleMeal } = usePlanMealConditions();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			error={error}
			rawIncludedMeals={rawIncludedMeals}
			onToggleMeal={onToggleMeal}
		/>
	);
};

QuestionPlanMealConditions.displayName = "QuestionPlanMealConditions";
